/*
 * Toolbar.
 *
 * Depends on:
 *   - main.js
 *   - dialog.js
 *   - I18n Messages:
 *      - button.close
 *      - dialog.error.ajax
 *      - form.characters.remaining
 *      - content.toolbar.print.selectProcedureDialog.title
 *      - content.toolbar.print.selectProcedureDialog.body
 */
(function ($i) {
    $i.initDocumentToolbar = function (documentId, isPdf) {
        function bytesToSize(bytes) {
            var sizes = ['B', 'KB', 'MB', 'GB', 'TB'];
            if (bytes == 0) return '0&nbsp;B';
            var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
            return (bytes / Math.pow(1024, i)).toFixed(i) + sizes[i];
        }
        $(function () {
            var toolbar = $('.toolbar');

            /* Print. */
            var plainPrintButton = toolbar.find('.document-toolbar-print').show();
            var printPdfContentButton = toolbar.find('.document-toolbar-print-pdf-content').show();
            if (plainPrintButton.length) {
                plainPrintButton.show().click(function (e) {
                    var targetIframe = $('.document-content').get(0);
                    var targetWindow = targetIframe.contentWindow;
                    var procedureIframe;

                    e.preventDefault();
                    var targetDocument = targetWindow.document;
                    procedureIframe = targetDocument.getElementById('procedure-iframe');

                    if (procedureIframe === null) {
                        var curNode = $(targetDocument).find('.document-tree li.active').last()
                            .find('li.procedure').addBack('li.procedure')
                            .filter(function (i, el) {
                                return $(el).css('display') !== 'none';
                            }).first();

                        procedureIframe = targetDocument.getElementById('procedure-iframe-' + curNode.data('node-id') + '-' + curNode.data('uid'));
                    }
                    var isTree = $(targetDocument).find('.document-tree').length > 0;
                    if (isTree && (procedureIframe === null || procedureIframe.src === 'about:blank')) {
                        $i.dialog({
                            'title': $i.i18n.get('content.toolbar.print.selectProcedureDialog.title'),
                            'body': $i.i18n.get('content.toolbar.print.selectProcedureDialog.body')
                        });
                        return;
                    }

                    if (procedureIframe !== null) {
                        targetIframe = procedureIframe;
                    }
                    targetWindow = targetIframe.contentWindow;

                    function openPrintDialog() {
                        $loading && $loading.detach && $loading.detach()
                        targetWindow.focus();
                        targetWindow.print();
                    }

                    var imagesToPrint = targetWindow.document.getElementsByTagName("img");

                    if (imagesToPrint.length === 0) {
                        return openPrintDialog();
                    }

                    // Display loading indicator
                    var $loading = $('<div class="document-loading-wrapper"><div class="document-loading"></div></div>')
                    var documentViewerBody = window.document.getElementById('documentViewContent')
                        .contentWindow.document.getElementById('document-viewer-body')
                    $loading = $loading.appendTo(documentViewerBody)

                    // Handle loading all images before opening print dialog
                    var loadedImagesCount = 0,
                        failedImagesCount = 0;
                    for (var i = 0; i < imagesToPrint.length; i++) {
                        var sourcePath;
                        if (typeof imagesToPrint[i].dataset["lazySrc"] !== "undefined") {
                            sourcePath = imagesToPrint[i].dataset["lazySrc"];
                        } else {
                            sourcePath = imagesToPrint[i].src;
                        }
                        imagesToPrint[i] = new Image();
                        imagesToPrint[i].loading = "eager"
                        imagesToPrint[i].onload = function () {
                            loadedImagesCount++;
                            if ((failedImagesCount + loadedImagesCount) === imagesToPrint.length) {
                                openPrintDialog();
                            }
                        }
                        imagesToPrint[i].onerror = function () {
                            failedImagesCount++;
                            if ((failedImagesCount + loadedImagesCount) === imagesToPrint.length) {
                                openPrintDialog();
                            }
                        }
                        imagesToPrint[i].src = sourcePath;
                    }
                });
            }

            /* Maximise. */
            toolbar.find('.document-toolbar-maximise').on('click', function (e) {
                e.preventDefault();
                var el = document.documentElement,
                    rfs = el.requestFullScreen || el.webkitRequestFullScreen || el.mozRequestFullScreen || el.msRequestFullscreen;
                if (typeof rfs != "undefined" && rfs) {
                    rfs.call(document.getElementById('procedure-title-and-content-wrapper'));
                }
            });

            /* Download. */
            toolbar.find('.document-toolbar-download').click(function (e) {
                e.preventDefault();
                window.open($(this).attr('href'));
            });

            var feedbackDialog;

            /* Feedback. */
            toolbar.find('.feedback-link').click(function (e) {
                var documentIframe = $('iframe.document-content');
                var activeProcedure = documentIframe.contents().find('.procedure.active');
                var procId = activeProcedure.size ? activeProcedure.attr('data-procedure-reference') : '';
                if (typeof procId == 'undefined') {
                    procId = '';
                }
                var url = $(this).attr('href') + '&procedureSourceId=' + procId + ' #feedback-content';

                var initDialog = function (box) {
                    var head = box.find('.dialog-head');
                    var body = box.find('.dialog-body');
                    var foot = box.find('.dialog-foot');
                    var textarea = body.find('textarea[name="feedback"]');

                    head.find('h2').replaceWith(body.find('#feedback-title'));
                    body.find('input[type="submit"], input[type="button"], button, .btn').hide();
                    foot.find('.feedback-ajax-submit').remove();
                    var form = body.find('form:has(input[type="submit"])');

                    $('<div><span class="feedback-limit"/> ' + $i.i18n.get('form.characters.remaining') + '</div>').insertAfter(textarea);

                    // AJAX Form
                    if (form.size() > 0) {
                        var button = form.find('input[type="submit"]');
                        $('<button class="btn btn-primary feedback-ajax-submit">' + button.attr('value') + '</button>').prependTo(foot).click(function () {
                            var $file = form.find("input[type='file']");
                            var filename = $file.val().split('\\').pop();
                            $('.escaped-file-name').val(encodeURI(filename));
                            var fiveMB = 5242880;
                            var isValid = !$file[0].files[0] || $file[0].files[0].size <= fiveMB;

                            if (!isValid) {
                                body.find('.dialog-error').remove();
                                var fileSize = $file[0].files[0].size;
                                body.prepend('<div class="alert alert-error dialog-error">' +
                                    '<strong>' + $i.i18n.get('content.document.feedback.upload.size.exceeded', bytesToSize(fileSize)) + '</strong>&nbsp;</div>');
                            } else {
                                var button = $(this);
                                setTimeout(function () {
                                    button.attr('disabled', 'true').append('<i class="icon icon-spinner icon-spin"></i>');
                                }, 0);
                                $.ajax({
                                    url: form.attr('action'),
                                    data: new FormData(form.get()[0]),
                                    type: 'POST',
                                    contentType: false,
                                    processData: false,
                                    success: function (data, textStatus, jqXHR) {
                                        var content = $(data).find('#feedback-content');
                                        body.empty().append(content);
                                        body.find('.dialog-error').remove();
                                        initDialog(box);
                                        if (content.hasClass('feedback-success')) {
                                            setTimeout(function () {
                                                if (feedbackDialog != null) {
                                                    feedbackDialog.destroy();
                                                }
                                            }, 5000);
                                        }
                                        feedbackDialog = null;
                                        setupRating($('#rating'));
                                    },
                                    error: function () {
                                        body.find('.dialog-error').remove();
                                        button.attr('disabled', 'false').find('.icon-spinner').remove();
                                        body.prepend('<div class="alert alert-error dialog-error">' + $i.i18n.get('dialog.error.ajax') + '</div>');
                                        feedbackDialog = null;
                                    }
                                });
                            }

                        });

                        $('textarea[name="feedback"]')
                            .after('<div><span id="feedback-limit"/> ' + $i.i18n.get('form.characters.remaining') + '</div>')
                            .maxlength({
                                feedback: '#feedback-limit',
                                disableItem: '.feedback-ajax-submit'
                            });
                    }
                };

                e.preventDefault();
                if (!feedbackDialog) {
                    feedbackDialog = $i.dialog({
                        url: url,
                        minWidth: 750,
                        maxWidth: 1000,
                        load: function () {
                            initDialog(this.box);
                        },
                        open: function () {
                            documentIframe.css('visibility', 'hidden');
                            setupRating($('#rating'));
                        },
                        close: function () {
                            documentIframe.css('visibility', 'visible');
                            feedbackDialog = null;
                        },
                        buttonKeys: {
                            'button.close': function () {
                                this.destroy();
                            }
                        },
                        titleKey: 'main.help.loading'
                    });
                }
            });

            /*
             * Watch.
             */
            toolbar.find('.document-toolbar-watch').on('click', function (e) {
                e.preventDefault();
                var $link = $(this),
                    $watchText = $link.find('span'),
                    $icon = $link.find('.icon'),
                    documentId = $link.data('documentId'),
                    currentWatchState = $link.hasClass('is-watched'),
                    newWatchState = !currentWatchState;
                $.ajax({
                    url: $i.contextPath + "/service/document/watch",
                    type: 'POST',
                    data: {documentId: documentId, watch: newWatchState},
                    success: function (data, textStatus, jqXHR) {
                        if ($link.hasClass('is-watched'))
                        {
                            $link.removeClass('is-watched');
                            $link.addClass('is-not-watched');
                            $link.attr('title', $i.i18n.get('content.toolbar.watch'));
                            $icon.removeClass('icon-eye-slash');
                            $icon.addClass('icon-eye');
                            $watchText.text($i.i18n.get('content.toolbar.watch'));
                        } else {
                            $link.removeClass('is-not-watched');
                            $link.addClass('is-watched');
                            $link.attr('title', $i.i18n.get('content.toolbar.unwatch'));
                            $icon.removeClass('icon-eye');
                            $icon.addClass('icon-eye-slash');
                            $watchText.text($i.i18n.get('content.toolbar.unwatch'));
                        }
                        $i.dialog({
                            bodyKey: newWatchState ? 'user.document.watch' : 'user.document.unwatch',
                            modal: true,
                            buttonKeys: {
                                'button.ok': function(){
                                    this.close();
                                }
                            }
                        });
                    },
                    error: function () {
                        $i.dialog({
                            bodyKey: 'user.document.watch.error',
                            modal: true,
                            buttonKeys: {
                                'button.ok': function(){
                                    this.close();
                                }
                            }
                        });
                    }
                });
            });
        });
    };

    function getWindowHash() {
        var parentWindowHash = '';
        // This should not fail but try/catch added to prevent script errors.
        try {
            parentWindowHash = window.location.hash;
        } catch (err) {
            // Do nothing.
        }
        return parentWindowHash;
    }

})(isis);
